'use strict';
import Common from '../../Utils/Common';

/**
 * @classname BtnApplyModalCoupon
 * @classdesc モーダルクーポン選択
 */
export default class BtnApplyModalCoupon {
	/**
	 * @constructor
	 * @param {jQuery} $e - #modal-coupon-select .block--coupon-box
	 * @param {instance} controller - controller instance
	 */
	constructor($e, controller) {
		console.log(`${this.constructor.name}.constructor`);
		this._$e = $e;
		this._couponId = $e.attr('data-coupon-id');
		$e.on('click', () => this.onClick());
	};


	/**
	 * clickのコールバック
	 *
	 * @memberof BtnApplyModalCoupon
	 * @return undefined
	 */
	onClick() {
		console.log(`${this.constructor.name}.onClick`);
		$('#coupon_id').val(this._couponId);
		$('#modal-coupon-select .close').click();
	};
};
